module.exports = __webpack_public_path__ + "img/dna-3539309.0b43c89a.jpg";